import PropertyColumn from './PropertyColumn';

export default PropertyColumn;
